import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@/locales/en.json';
import es from '@/locales/es.json';
import he from '@/locales/he.json';

export type LanguageCode = 'en' | 'es' | 'he';

const RTL_LANGUAGES: LanguageCode[] = ['he'];

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    he: { translation: he },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export function setLanguage(lang: LanguageCode) {
  void i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
  document.documentElement.dir = RTL_LANGUAGES.includes(lang) ? 'rtl' : 'ltr';
}

document.documentElement.lang = 'en';
document.documentElement.dir = 'ltr';

export default i18n;
